import { tenantDetails } from '../../../helpers/utils/types';

type ProfileHeaderCardProps = {
  fullName: string;
  initials: string;
  tenantData: tenantDetails | null;
};

const ProfileHeaderCard = ({ fullName, initials, tenantData }: ProfileHeaderCardProps) => (
  <div className='prof-hdr'>
    <div className='prof-av'>{initials}</div>
    <div>
      <div className='prof-name'>{fullName}</div>
      <div className='prof-email'>{tenantData?.user?.email || '-'}</div>
      {tenantData?.user?.isEmailVerified ? (
        <div className='prof-verified'>
          <div className='pv-dot' aria-hidden />
          <span className='pv-txt'>Email verified</span>
        </div>
      ) : null}
    </div>
  </div>
);

export default ProfileHeaderCard;
